import { axios } from "@/core/axios";
import { PageGrid, Page, UpdatePageResponse } from "../types";
import { Widget } from "@/modules/widgets";

export interface CreatePageRequest {
    title: string;
    dashboardId: number;
    pagePrompt?: string;
    createdBy?: string;
    publishedToAll?: boolean;
}

export interface CreatePageResponse {
    page: Page;
}

export interface GetPageInsightsResponse {
    sucess: boolean;
    insights: string | null;
    recommendations: string | null;
}

export const pageEndpoints = {
    createPage: async (request: CreatePageRequest): Promise<Page | undefined> => {
        try {
            const response = await axios.post<CreatePageResponse>("/pages", {
                ...request,
            });

            return response.data.page;
        } catch (error) {
            console.error("Error creating page:", error);
            return undefined;
        }
    },

    updatePage: async (id: number, pageTabId?: number, updates: Partial<Page> | { grid?: Partial<PageGrid> } = {}): Promise<Page | undefined> => {
        try {
            const { grid, ...rest } = updates;
            const response = await axios.put<Page>("/pages", {
                page: {
                    id,
                    ...rest,
                },
                pageTabId,
                grid,
            });

            return response.data;
        } catch (error) {
            console.error("Error updating page:", error);
            return undefined;
        }
    },

    deletePage: async (pageId: number): Promise<boolean> => {
        try {
            const response = await axios.delete(`/pages?pageId=${pageId}`);
            return response.status === 200;
        } catch (error) {
            console.error("Error deleting page:", error);
            return false;
        }
    },
    getPageInsights: async (page: Omit<Page, "widgets"> & { widgets: (Widget & { data: any })[] }): Promise<GetPageInsightsResponse | undefined> => {
        try {
            const response = await axios.post<GetPageInsightsResponse>("/page-insights", page);
            return response.data;
        } catch (error) {
            console.error("Error getting page insights:", error);
            return undefined;
        }
    },
};
